import React from 'react'
import { Alert } from '@mui/material'

/**
 * Warns when a company has no AX orders in the campaign window, since it is then absent from both
 * the points list and the draw pool. Renders nothing until the points arrive.
 */
export const NoOrdersAlert = ({ points }) => {
  if (!points || Object.keys(points.details).length > 0) return null

  return (
    <Alert severity='warning' sx={{ mb: 2 }}>
      This company has no orders in the campaign window, so it does not appear in the points list or
      the draw pool — tickets set here will not take effect.
    </Alert>
  )
}
